import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Incident from "./components/Incident";
import Maintenance from "./components/Maintenance";
import Component from "./components/Component";
import PastIncidents from "./components/PastIncidents";
import { useQuery, useMutation } from "react-query";
import useIncidents from "../common/hooks/pages/useHistroy";
import useSubscribers from "../common/hooks/pages/useSubscribers";
import { usePopup } from "../common/contexts/PopupContext";

function Dashboard() {
  const { getIncidents } = useIncidents();
  const { createSubscriber } = useSubscribers();
  const { toast } = usePopup();
  const { data } = useQuery({
    retry: false,
    queryKey: "getIncidents",
    queryFn: getIncidents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting incidents!";
      toast(message, "error");
    },
  });

  const today = new Date();
  const dates = [];
  for (let i = 89; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split("T")[0]);
  }

  const [isTextFieldVisible, setTextFieldVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const { mutate: createSubscriberMutation } = useMutation({
    mutationFn: createSubscriber,
    onSuccess: (res) => {
      const { message } = res?.data || {};
      toast(message, "success");
      setTextFieldVisible(false);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while Subscribe!";
      toast(message, "error");
      setTextFieldVisible(false);
    },
  });

  const toggleTextField = () => {
    setTextFieldVisible(!isTextFieldVisible);
  };

  const handleModalContentClick = () => {
    setTextFieldVisible(false);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email) {
      setEmailError("Email is required");
    } else {
      setEmailError("");
      createSubscriberMutation({ email });
    }
  };

  useEffect(() => {
    const showTextFieldBtn = document.getElementById("showTextFieldBtn");
    showTextFieldBtn.addEventListener("click", toggleTextField);

    return () => {
      showTextFieldBtn.removeEventListener("click", toggleTextField);
    };
  }, []);

  return (
    <div style={{ paddingRight: "10px" }}>
      <br />
      <button
        id="showTextFieldBtn"
        style={{ float: "right" }}
        className={`rounded-md common_bg text-white w-half px-4 py-2 nav_link-500 transition ease-in-out duration-300 }`}
      >
        Subscribe to updates
      </button>
      <br />
      {isTextFieldVisible && (
        <div className="text-gray-700">
          <div className="fixed top-0 left-0 w-screen h-screen z-[99] bg-gray-400 bg-opacity-50 transistion ease-in-out duration-300"></div>

          <div className="fixed top-0 left-0 w-screen h-screen z-[999] transistion ease-in-out duration-300 flex justify-center items-center">
            <div
              className={`min-w-[250px] bg-white rounded-md shadow-md p-4 } max-h-[70vh] overflow-y-auto`}
            >
              <div className="flex justify-between items-center">
                <div className=" text-xl">Subscribe for updates</div>

                <button
                  className="hover:bg-gray-100"
                  onClick={handleModalContentClick}
                >
                  <span style={{ color: "red" }}>x</span>
                </button>
              </div>
              <div className="mt-6">
                <form onSubmit={handleSubmit}>
                  <label>Email</label>
                  <br />
                  <input
                    type="email"
                    className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full
                  }`}
                    value={email}
                    onChange={handleEmailChange}
                    required
                  />
                  {emailError && (
                    <div className="text-red-500">{emailError}</div>
                  )}
                  <br />
                  <br />
                  <button
                    type="submit"
                    className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300 }`}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      <br />
      <div className="children-position" style={{ paddingRight: "8rem" }}>
        <Incident data={data} />
        <Outlet />
      </div>
      {data?.data?.data?.componentData?.map((component, i) => (
        <Component
          key={component.component}
          component={component}
          dates={dates}
          data={data}
        />
      ))}
      <div className="children-position" style={{ paddingRight: "8rem" }}>
        <Maintenance data={data} />
      </div>
      <PastIncidents dates={dates} data={data} />
    </div>
  );
}

export default Dashboard;
